import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { ravelComponentPath } from '../../../../common/ravelComponentPath.js';

export class RavelScrapbook extends RavelElement {
    static get localStyles() {
        return `
        <style>
            #blocker {
                display: none;
                background-color: rgba(0, 0, 0, 0.5);
                position: fixed;
                top: 0px;
                left: 0px;
                width: 100vw;
                height: 100vh;
            }
            #container {
                user-select: none;
                border: 10px solid rgba(255, 255, 255, 0.80);
                border-radius:20px;
                overflow:hidden;
                touch-action: none;
                cursor: pointer;
                overscroll-behavior: none; 
            }
            #icon {
                min-width: 200px;
                width: 100%;
                max-width: 200px;
                max-height: 200px;
                aspect-ratio: 1 / 1;
                object-fit: cover; 
                user-select: none;
                display: block;
            }
            #container:focus {
                background-color: #ffff00;
                outline: 5px solid #ffff00; 
            } 

            #close:focus, a:focus {
                outline: 5px solid #ffff00; 
                background-color: #ffff00;
            }
            
            #reader {
                display: none;
                visibility: hidden;
                position: fixed;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 90%;
                padding: 40px 0px;
                max-width: 1000px;
                height: 100%;
                background-color: rgba(255, 255, 255, 1.0);
                box-shadow : 0px 0px 0px 10px rgba(255, 255, 255, 0.5);
                overflow: hidden;
                overscroll-behavior: none; 
                transition: visibility 0.3s ease;
            }
            #reader-content {
                font-family: Quantico;
                font-size: 14pt;
                line-height: 18pt;
                height: 100%;
                overflow-y: scroll;
                overscroll-behavior: none; 
                display: flex;
                flex-direction: column;
                align-items: center;
            }
            .featured-image, .double-border {
                max-width: 800px;
                border: 10px solid #ffff00;
                box-shadow: 0px 0px 0px 10px #ff0000;
                border-radius: 24px;
                margin: 10px;
            }
            .featured-image-wrapper {
                margin-top: 20px;
            }
            .date-header {
                display: inline-block;
                font-weight: 900;
                font-size: 24pt;
                line-height: 24pt;
                color: #ffffff;
                background-color: #ff0000;
                padding: 5px 20px;
                position: relative;
                top: -10px;
                border-bottom-left-radius: 10px;
                border-bottom-right-radius: 10px;        
            }
            h1 { 
                width: 90%;
                text-align: center;
                font-weight: 900;
                font-size: 28pt;
                line-height: 28pt;
            }
            .image-caption {
                margin-right: -18px;
                font-size: 8pt;
                display: inline-block;
                writing-mode: vertical-rl;
                text-orientation: sideways;
            }
            p, ul, ol {
                width: 90%;
                max-width: 840px;
                margin: 10px auto 10px auto;
            }
            #close {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                position: absolute;
                right: 20px;
                top: 50px;
                border: none;
                z-index: 3;
                padding: 10px;
                background-color: #ffffff;
                border-radius: 50%;

            }
            #loading {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 150px;
            }
            .medium-img {
                width: 600px;
            }
            .medium-small-img {
                width: 300px;
            }
            .small-img {
                width: 125px;
            }
            .full-width {
                width: 90%;
            }
            .footer {
                width: 100%;
                min-height: 100px;
                background-image: url(images/icon-multicolor.png);
                background-position: center;
                background-size: 50px;
                background-repeat: no-repeat;
            }
            .space-before {
                margin-top: 30px;
            }
            .arrow {
                position:relative;
                top:-15px;
                margin-right:-10px;
                border: solid black;
                border-width: 0 3px 3px 0;
                display: inline-block;
                padding: 3px;
            }
            .right {
                transform: rotate(-45deg);
                -webkit-transform: rotate(-45deg);
            }

            .left {
                transform: rotate(135deg);
                -webkit-transform: rotate(135deg);
            }
            .up {
                transform: rotate(-135deg);
                -webkit-transform: rotate(-135deg);
            }
            .down {
                transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
            }
            .caption-box {
                margin-top:10px;
                padding:20px;
                border:1px dotted #444444;
                background:#ffffef;
            }
            .resource-collection {
                max-width: 90%;
            }
            @media (max-width: 600px) {
                #reader-content {
                    font-size: 12pt;
                    line-height: 14pt;
                    padding-top: 60px;
                }
                .featured-image {
                    max-width: 300px;
                }
                .medium-img {
                    width: 200px;
                }
                .medium-small-img {
                    width: 100px;
                }
                .small-img {
                    width: 50px;
                }
                h1 {
                    padding: 0px 5px;
                    font-size: 24pt;
                    line-height: 24pt;
                }
                .footer {
                    min-height: 200px;
                }
                .date-header {
                    top: -12px;
                }
                iframe {
                    max-width: 300px;
                }
            }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="blocker"></div>
        <div id="container" tabindex="0">
            <img id="icon" tabindex="-1" src="${ravelComponentPath}/images/default-backgrounds/0.png"/>
            <div id="reader" role="dialog" aria-modal="true" tabindex="-1">
                <div id="reader-content" tabindex="0">
                    <div id="loading">🧶</div>
                </div>
                <button id="close" type="button" aria-label="Close">
                    <img src="${ravelComponentPath}/images/close-black.svg">
                </button>
            </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'icon', 'src', 'max-width', 'anchor', 'label', 'external-link'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.iconButton = this.shadowRoot.querySelector('#icon');
        this.reader = this.shadowRoot.querySelector('#reader');
        this.readerContent = this.shadowRoot.querySelector('#reader-content');
        this.blocker = this.shadowRoot.querySelector('#blocker');
        this.close = this.shadowRoot.querySelector('#close');
        this.anchor = null;
        this.label = 'label';
        this.src = null;
        this.icon = `${ravelComponentPath}/images/default-backgrounds/0.png`;
        this.readerOpen = false;
    }
  
    setup = () => {
        this.observedMessages = ['scrapbook'];
        this.subscribe(this.observedMessages);   
        this.shadowRoot.querySelector('#icon').src = this.icon;
        this.addEventListener('keydown', this.handleKeyDown);
        this.iconButton.addEventListener('click', this.handleClick);
        this.close.addEventListener('keydown', this.handleKeyDown);
        this.close.addEventListener('click', this.handleClick);
        this.addEventListener('scrapbook', this.handleExternalMessage);
        this.container.setAttribute('aria-label', this.label);
        this.container.setAttribute('role', 'button');
        this.iconButton.setAttribute('aria-label', this.label);
    }
    
    teardown = () => {
        this.unsubscribe(this.observedMessages);
        this.container.removeEventListener('keydown', this.handleKeyDown);
        this.iconButton.removeEventListener('click', this.handleClick);
        this.close.removeEventListener('keydown', this.handleKeyDown);
        this.close.removeEventListener('click', this.handleClick);
        this.removeEventListener('scrapbook', this.handleExternalMessage);
    }

    handleClick = (evt) => {
        evt.preventDefault();
        evt.stopPropagation();
        if (this.externalLink) {
            window.open(this.externalLink, '_blank', 'noopener,noreferrer');
            return;
        }
        if (this.readerOpen) {
            this.closeScrapbook();
        } else {
            this.openScrapbook();
        }
    }

    handleKeyDown = (evt) => {
        //console.log((this.readerOpen && (evt.target === this.container) && (evt.key === 'Tab') && (evt.shiftKey)));
        // Capture tab events on close to keep focus within the reader
        if ((evt.target === this.close) && (evt.key === 'Tab') && (!evt.shiftKey)) {
            evt.preventDefault();
            evt.stopPropagation();
            this.closeScrapbook();
            return;
        }
        // Capture back tab on container
        console.log((this.readerOpen && (evt.target === this.container) && (evt.key === 'Tab') && (evt.shiftKey)));
        if (this.readerOpen && (evt.target === this.container) && (evt.key === 'Tab') && (evt.shiftKey)) {
            evt.preventDefault();
            evt.stopPropagation();
            return;
        }
        if ((evt.key !== 'Enter') && (evt.key !== 'Space')) return;
        evt.preventDefault();
        evt.stopPropagation();
        if (this.externalLink) {
            window.open(this.externalLink, '_blank', 'noopener,noreferrer');
            return;
        }
        if (this.readerOpen) {
            this.closeScrapbook();
        } else {
            this.openScrapbook();
        }
    }

    handleExternalMessage = (evt) => {
        if (!this.anchor || !evt.detail.content) return;
        // responds to an open-scrapbook event targeting this anchor
        if (evt.detail.cmd === 'open') {
            if (evt.detail.content === this.anchor) {
                this.scrollIntoView({
                    behavior: 'smooth', 
                    block: 'start'     
                });
                this.focus();
                this.openScrapbook();
            }
        }
        if (evt.detail.cmd === 'close') {
            if (evt.detail.content === this.anchor) {
                this.closeScrapbook();
            }
        }
    }

    openScrapbook = () => {
        this.readerOpen = true;
        this.reader.style.display = 'block';
        this.reader.style.visibility = 'visible';
        this.blocker.style.display = 'block';
        this.fetchScrapbook();
        this.container.classList.add('selected');
        document.querySelector('body').style.overflow = 'hidden';
    }

    closeScrapbook = () => {
        this.readerOpen = false;
        this.reader.style.display = 'none';
        this.reader.style.visibility = 'hidden';
        this.blocker.style.display = 'none';
        this.shadowRoot.querySelector('#reader-content').innerHTML = `<div id="loading" class="pulse">🧶</div>`;
        this.container.classList.remove('selected');
        this.container.focus();
        document.querySelector('body').style.overflow = 'auto';
    }

    fetchScrapbook = () => {
        // Fetch the scrapbook
        if (this.src) {
            fetch(
                this.src,
                { 
                    method: "GET", 
                    headers: { "Content-Type": "text/plain", "pragma": "no-cache", "cache-control": "no-cache" }
                }
            )
            .then(response => response.text())
            .then(text => {
                this.shadowRoot.querySelector('#reader-content').innerHTML = text;
                this.readerContent.focus();
            })
            .catch(error => {
                console.warn(error);
            });
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'icon') {
            this.icon = newValue;
        }
        if (name === 'src') {
            this.src = newValue;
        }
        if (name === 'max-width') {
            this.maxWidth = parseInt(newValue, 10);
        }
        if (name === 'anchor') {
            this.anchor = newValue;
        }
        if (name === 'label') {
            this.label = newValue;
        }
        if (name === 'external-link') {
            this.externalLink = newValue;
        }
    }
}
